import React from 'react';

interface SearchFormProps {
    setSearchTerm: (term: string) => void;
    performSearch: () => void;
    placeholder: string;
}

export const SearchForm: React.FC<SearchFormProps> = ({ setSearchTerm, performSearch, placeholder }) => {
    return (
        <>
            <form className="inline-input-form search-form" onSubmit={(e) => {
                e.preventDefault();
                performSearch();
            }}>
                <label htmlFor="searchInput" className="visually-hidden">Search</label>
                <input type="text" id="searchInput" className="search-input" onChange={(e) => {
                    setSearchTerm(e.target.value);
                }} placeholder={placeholder} />
                <button type="submit" className="btn-secondary">
                    Search
                </button>
            </form>
        </>
    )
}